import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { useReduxSelector } from 'store'
import { DAY } from 'utils/date'

export type RentalStatus =
  | { key: 'availableIn', days: number }
  | { key: 'collectionBlockTitle' | 'cancelledRental' | 'completedRental' | 'parkingBlocked' | 'carBlocked' | 'storageLocked' | 'accessBlocked' }

const useRentalStatus = (id: string, object: 'warehouse' | 'gate' = 'warehouse'): RentalStatus | null => {
  const { inFuture, hasAccessByFlag, resignation, hasAccess, rentableType, fullDateFrom } = useReduxSelector(state => selectWarehouse(state, id))

  if (inFuture) return { key: 'availableIn', days: Math.ceil((new Date(fullDateFrom).getTime() - Date.now()) / DAY) }
  if (hasAccessByFlag === false) return { key: 'collectionBlockTitle' }
  if (resignation?.isCompleted) return { key: resignation?.type === 'cancel' ? 'cancelledRental' : 'completedRental' }
  if (hasAccess === false) return { key: object === 'gate' ? 'accessBlocked' : rentableType === 'parking' ? 'parkingBlocked' : rentableType === 'car' ? 'carBlocked' : 'storageLocked' }
  return null
}

export default useRentalStatus
